/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurants`
};

const en_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurants`
};

const es_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurantes`
};

const fr_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurants`
};

const it_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Ristoranti`
};

const nl_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurants`
};

const pt_poi_categories__restaurant = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurantes`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_categories__restaurant(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_categories__restaurant", locale)
	if (locale === "de") return de_poi_categories__restaurant(inputs)
	if (locale === "en") return en_poi_categories__restaurant(inputs)
	if (locale === "es") return es_poi_categories__restaurant(inputs)
	if (locale === "fr") return fr_poi_categories__restaurant(inputs)
	if (locale === "it") return it_poi_categories__restaurant(inputs)
	if (locale === "nl") return nl_poi_categories__restaurant(inputs)
	return pt_poi_categories__restaurant(inputs)
};